export const DEFINE_MODULE = {
  name: "môn học",
  fields: "subjects"
}
